var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      { staticClass: "projects-list flex flex-col mt-8 gap-2" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass:
              "project-item relative flex justify-between bg-white text-blue px-4 py-5 sm:px-8 sm:py-6 cursor-pointer shadow-transparent",
            class: item.isSold
              ? "opacity-30"
              : "group hover:scale-[1.01] duration-300",
          },
          [
            _c(
              "a",
              {
                staticClass:
                  "absolute inset-0 border border-transparent focus-visible:border-blue/50 group-hover:shadow-md focus-visible:shadow-md duration-300 outline-none text-[0px]",
                attrs: { href: item.url },
              },
              [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "shrink-0 lg:w-[75px] xl:w-[90px] max-w-[90px] lg:h-[75px] xl:h-[90px]",
              },
              [
                _c("img", {
                  staticClass: "object-contain max-w-full max-h-full",
                  attrs: { src: item.image, alt: item.title },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col sm:flex-row w-full justify-between sm:items-center ml-6 sm:mx-6 lg:ml-4 lg:mr-0 xl:mx-10",
              },
              [
                _c("div", { staticClass: "flex flex-col" }, [
                  _c(
                    "h3",
                    { staticClass: "text-lg sm:text-xl xl:text-2xl title" },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.title) + "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2 sm:mt-3 text-lg whitespace-nowrap" },
                    [
                      !item.isSold
                        ? _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.price(item.price)) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.isSold ? _c("p", [_vm._v("Sold")]) : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass:
                      "flex flex-col mt-4 sm:mt-0 lg:mt-0 lg:ml-5 xl:ml-8 whitespace-nowrap",
                  },
                  [
                    item.surface
                      ? _c("li", { staticClass: "flex items-center gap-4" }, [
                          _c("svg", { staticClass: "w-4 h-4" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#gross-floor" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(item.surface) + " m"),
                            _c("sup", [_vm._v("2")]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.rooms
                      ? _c("li", { staticClass: "flex items-center gap-4" }, [
                          _c("svg", { staticClass: "w-4 h-4" }, [
                            _c("use", {
                              attrs: { "xlink:href": "#number-of-rooms" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(item.rooms) +
                                " " +
                                _vm._s(
                                  _vm.pluralize(item.rooms, "room", "rooms")
                                )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.floors
                      ? _c("li", { staticClass: "flex items-center gap-4" }, [
                          _c("svg", { staticClass: "w-4 h-4" }, [
                            _c("use", { attrs: { "xlink:href": "#floors" } }),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(item.floors) +
                                " " +
                                _vm._s(
                                  _vm.pluralize(item.floors, "floor", "floors")
                                )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "hidden sm:flex lg:hidden xl:flex items-center" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "arrow-diagonal relative w-[18px] h-[18px] overflow-hidden",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "arrow-diagonal-wrapp w-full h-full" },
                      [
                        _c(
                          "svg",
                          {
                            staticClass:
                              "absolute w-[18px] h-[18px] translate-x-[-200%] translate-y-[-200%] group-hover:translate-x-0 group-hover:translate-y-0 duration-500 ease-basic-ease transition-transform",
                          },
                          [_c("use", { attrs: { "xlink:href": "#arrow-45" } })]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass:
                              "absolute w-[18px] h-[18px] group-hover:translate-x-full group-hover:translate-y-full duration-500 ease-basic-ease transition-transform",
                          },
                          [_c("use", { attrs: { "xlink:href": "#arrow-45" } })]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }